import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {MatRadioChange} from '@angular/material';
import {ReferenciasCFEDTO} from '../../../models/dtos/ReferenciasCFEDTO';
import {TipoCFEDTO} from '../../../models/dtos/TipoCFEDTO';
import {DatosInicioReferenciasDTO} from '../../../models/dtos/datosInicio/DatosInicioReferenciasDTO';
import {Utils} from '../../utils/utils';

@Component
({
  selector: 'app-referencias',
  templateUrl: './referencias.component.html',
  styleUrls: ['./referencias.component.scss']
})
export class ReferenciasComponent implements OnInit
{
  @Input()
  referenciasCFEDTO: ReferenciasCFEDTO;

  @Input()
  datosInicioReferenciasDTO: DatosInicioReferenciasDTO;

  @Input()
  esEResguardo: boolean;

  @Input()
  parentFormGroup: FormGroup;

  noReferencias = false;
  referenciaEsp = true;
  referenciaGlob = false;

  disableReferencias = false;
  detallesConReferencias = false;

  constructor()
  {

  }

  ngOnInit()
  {

  }

  get tipoReferenciaControl(): AbstractControl
  {
    return this.parentFormGroup.get('tipoReferenciaControl');
  }

  get tipoCFEReferenciaControl(): AbstractControl
  {
    return this.parentFormGroup.get('tipoCFEReferenciaControl');
  }

  get serieReferenciaControl(): AbstractControl
  {
    return this.parentFormGroup.get('serieReferenciaControl');
  }

  get numeroReferenciaControl(): AbstractControl
  {
    return this.parentFormGroup.get('numeroReferenciaControl');
  }

  get fechaEmisionReferenciaControl(): AbstractControl
  {
    return this.parentFormGroup.get('fechaEmisionReferenciaControl');
  }

  get razonReferenciaControl(): AbstractControl
  {
    return this.parentFormGroup.get('razonReferenciaControl');
  }

  public onTipoReferenciaChange(matRadioChange: MatRadioChange): void
  {
    this.disableReferencias = matRadioChange.value == 'NO_REFERENCIA';
    if (this.disableReferencias) {
      this.serieReferenciaControl.reset();
      this.numeroReferenciaControl.reset();
      this.fechaEmisionReferenciaControl.reset();
      this.razonReferenciaControl.reset();
    }
    this.datosInicioReferenciasDTO.mostrarReferenciaEspecifica = ('REF_ESPECIFICA' === matRadioChange.value);

    if (!this.detallesConReferencias) {
      this.referenciaGlob = 'REF_GLOBAL' === matRadioChange.value
    }
  }

  public onTipoCFEChange(): void
  {
    this.referenciasCFEDTO.referenciaCFE.tipoCFE = this.obtenerTipoCFE(this.datosInicioReferenciasDTO.codigoTipoCFESeleccionado);
  }

  private obtenerTipoCFE(codigoTipoCFE: number): TipoCFEDTO
  {
    let tipoCFEARetornarDTO: TipoCFEDTO = null;
    for (const tipoCFEDTO of this.datosInicioReferenciasDTO.tiposCFEsDTOs)
    {
      if (tipoCFEDTO.codigo === codigoTipoCFE)
      {
        tipoCFEARetornarDTO = tipoCFEDTO;
        break;
      }
    }

    return tipoCFEARetornarDTO;
  }

  public calcularCantidadCaracteresRestantes(): number
  {
    const cantidadCarateresRazonReferencia: number = (Utils.isNotNullOrUndefined(this.referenciasCFEDTO.razonReferencia)) ? this.referenciasCFEDTO.razonReferencia.length : 0;
    const cantidadCaracteresRestantes: number = 90 - cantidadCarateresRazonReferencia;

    return cantidadCaracteresRestantes;
  }

  convertirAMayusculas(event: any) {
    const expresionRegular = /^[a-mo-zA-Z]{1,2}$/;
    if (expresionRegular.test(event.target.value)) {
      this.referenciasCFEDTO.referenciaCFE.serie = event.target.value.toUpperCase();
    } else {
        this.referenciasCFEDTO.referenciaCFE.serie = '';
        this.serieReferenciaControl.setValue('');
    }
  }

  updateTabs(desahabilitarReferencia: boolean) {
    this.detallesConReferencias = desahabilitarReferencia;
    this.disableReferencias = this.detallesConReferencias;
    if (this.esEResguardo) {
      this.parentFormGroup.get('tipoReferenciaControl').setValidators(null);
      if (this.referenciaGlob && !desahabilitarReferencia) {
        this.parentFormGroup.get('tipoReferenciaControl').setValue('REF_GLOBAL');
      } else {
        this.referenciasCFEDTO.limpiar();
        this.referenciaGlob = false;
        this.noReferencias = true;
        this.referenciasCFEDTO.tipoReferencia = 'NO_REFERENCIA'
      }
      this.parentFormGroup.get('tipoCFEReferenciaControl').setValidators(null);
      this.parentFormGroup.get('serieReferenciaControl').setValidators(null);
      this.parentFormGroup.get('numeroReferenciaControl').setValidators(null);
      this.parentFormGroup.get('fechaEmisionReferenciaControl').setValidators(null);
    }
  }

}
